<template>
  <div class="calico-file-dropzone-page">
    <div class="calico-file-dropzone-container">
      <CalicoFileDropzone
        accept=".pdf, .png, .jpeg"
        @onBrowse="onBrowse"
      />
    </div>
  </div>
</template>

<script lang="js">
import CalicoFileDropzone from '@/components/calico/fileDropzone/index.vue'
export default {
  name: 'CalicoFileDropzonePage',
  components: {
    CalicoFileDropzone
  },
  data () {
    return {}
  },
  methods: {
    onBrowse (e) {
      console.log('file ==> ', e)
    }
  }
}
</script>
<style lang="scss">
.calico-file-dropzone-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-file-dropzone-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 510px;
  }
}
</style>
